import { BaseFrameworkError } from "@bloglovin/vue-framework";

class BrandingError extends BaseFrameworkError {}

export default BrandingError;
